import { useLayoutEffect, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const createAppTheme = (mode) => {
  const dark = mode === 'dark';
  return createTheme({
    palette: {
      mode,
      // Keep these semantic colors aligned with theme.css. MUI's color
      // utilities need concrete colors rather than CSS custom properties.
      primary: { main: dark ? '#8b9aff' : '#5468ff' },
      secondary: { main: '#11cb5f' },
      background: { default: dark ? '#000000' : '#ffffff', paper: dark ? '#1c1c1e' : '#ffffff' },
      text: { primary: dark ? '#f5f5f7' : '#202124', secondary: dark ? '#a1a1a6' : '#69696e' },
      divider: dark ? 'rgba(84, 84, 88, .65)' : 'rgba(60, 60, 67, .16)',
      error: { main: dark ? '#ff7474' : '#b42318' },
    },
    components: {
      MuiModal: {
        defaultProps: {
          // Keep modal/ARIA ownership stable while resizing the desktop frame.
          container: () => document.getElementById('appViewport') || document.body,
          disableScrollLock: true,
        },
      },
      MuiPaper: {
        // iOS raised surfaces use a solid semantic fill, including drawers.
        styleOverrides: { root: { backgroundImage: 'none' } },
      },
    },
  });
};

export default function AppThemeProvider({ children }) {
  const dark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const mode = dark ? 'dark' : 'light';
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  useLayoutEffect(() => {
    // Also reaches body-level portals and updates before the next paint.
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
